// The meeting the person has joined and not left on purpose (COMX-FE-02). When they navigate away
// from the room the "Revenir à la réunion" bar reads it. UI state only, never server data: the
// bar still asks the API whether the meeting is live. Nothing here is a secret.
import { useStore } from 'zustand';
import { createStore, type StoreApi } from 'zustand/vanilla';

interface ActiveMeetingState {
  meeting: { id: string; title: string } | null;
  enter: (meeting: { id: string; title: string }) => void;
  clear: () => void;
}

export const activeMeetingStore: StoreApi<ActiveMeetingState> = createStore<ActiveMeetingState>()(
  (set) => ({
    meeting: null,
    enter: (meeting) => {
      set({ meeting });
    },
    clear: () => {
      set({ meeting: null });
    },
  }),
);

export function useActiveMeeting(): ActiveMeetingState['meeting'] {
  return useStore(activeMeetingStore, (state) => state.meeting);
}
